import { isFeatureEnabled } from 'owa-feature-flags';

export default function getAdExpFlights(): string[] {
    return [
        'adsexp-Display-7s',
        'adsexp-Display-cr',
        'adsExp-NativeInbox-e2-NoDisplayAd',
        'adsExp-NativeInbox-e3-NoDisplayAd',
        'adsExp-NativeInbox-e4-NoDisplayAd',
        'adsExp-NativeInbox-e3-DisplayAd',
        'adsExp-NativeInbox-control',
        'adsExp-NativeTwoAds-e1',
        'adsExp-NativeTwoAds-e2',
        'adsExp-NativeTwoAds-e3',
        'adsExp-NativeTwoAds-control',
        'adsexp-NRExitRp-treatment',
        'adsexp-NRExitRp-control',
        'adsexp-NRExitRpThrottle-cr',
        'adsexp-NRExitRpThrottle-5s',
        'adsexp-NRExitRpThrottle-10s',
        'adsexp-NRExitRpThrottle-15s',
        'adsexp-NRExitRpThrottle-20s',
    ].filter(isFeatureEnabled);
}
